<template>
    <section class="character-wrap" :class="{ 'mask': !showRole }">
        <audio ref="say" @canplay="canplay=true" @pause="pause" @ended="playing=false" @playing="playing=true" v-if="seledRole" :src="seledRole.cvFile"></audio>
        
        <div class="camp-wrap">
            <!-- 阵营选择 -->
            <ul class="camp-container">
                <template v-for="(item, index) in camplist">
                    <transition :name="slideType(index)" :key="`camp-${index}`">
                        <li
                            class="camp-box"
                            :class="{'actived': item.stage <= CAMP_STAGE}"
                            v-show="showCamp"
                            @click="showCampRole(item, index > CAMP_STAGE)"
                        >
                            <img class="camp-bg" :src="campBg(item)" alt />
                        </li>
                    </transition>
                </template>
            </ul>
        </div>
        <!-- 阵营logo -->
        <div v-if="seledCampData" class="camp-logo" @click="returnCamplist">
            <a href="javascript:void(0)">
                <img :src="seledCampData.campLogo" alt />
            </a>
        </div>
        <!-- 角色选择 -->
        <div class="role-wrap" v-show="showRole">
            <!-- 真实角色列表 -->
            <ul class="role-container">
                <li
                    class="role-box"
                    v-for="(item, index) in seledCampData.rolelist"
                    :key="`role-${index}`"
                >
                    <div
                        class="role-content"
                        :class="[hoverClass(index),  seledClass(index)]"
                        :style="[posLeft(index, seledCampData.rolelist.length), item.roleStyle]"
                    >
                        <img class="role" :style="item.imgStyle" :src="item.roleImg" alt />

                        <transition name="roleDetail">
                            <div class="role-detail" v-show="seledRoleIndex == index">
                                <transition name="roleClass">
                                    <div class="role-class" v-show="seledRoleIndex == index">
                                        <img :src="item.roleClass" alt />
                                    </div>
                                </transition>
                                <!-- <div class="role-close" @click="closeRole">
                                    <img src="../../assets/images/home/character/role/role_close.png" alt />
                                </div> -->
                                <i class="iconfont iconguanbi1 role-close" @click="closeRole"></i>
                                <div class="role-name-cv-box">
                                    <div class="role-cv">
                                        <div class="role-cv-box" ref="role-cv-box" :class="{ 'play': playing }">
                                            <img
                                                src="../../assets/images/home/character/role/role_cv_close.png"
                                                class="cv-btn"
                                                alt
                                            />
                                        </div>
                                        <span class="cv">{{ item.roleCv }}</span>
                                    </div>
                                    <div class="role-name">
                                        <img :src="item.roleName" alt />
                                    </div>
                                </div>
                                <div class="role-text" v-html="item.roleText"></div>
                            </div>
                        </transition>
                    </div>
                </li>
            </ul>
            <!-- 触发mouseover,click事件列表 -->
            <ul class="mover-container">
                <li
                    class="mover-box"
                    v-for="(item, index) in seledCampData.rolelist"
                    :style="posLeft(index, seledCampData.rolelist.length)"
                    :key="`mover-${index}`"
                    @mouseover="moverRole(index)"
                    @mouseleave="mouseleaveRole"
                    @click="selRole(index, seledRoleIndex != -1)"
                ></li>
            </ul>

            <span class="cv-more" @click="jumpToCv">
                CV영상 및 진영소개 
            </span>
        </div>
        <span class="cv-hover" :style="cvHoverPosit"  v-show="seledRoleIndex != -1" @click="playAudio"></span>
        
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
    name: "Character",
    components: {
        
    },
    data: () => ({
        camplist: [
            {
                closeImg: "",
                openImg: require("../../assets/images/home/character/camp/camp01_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp01_actived.png"),
                stage: 0,
                campLogo: require("../../assets/images/home/character/role/camp01/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp01/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/vanguard.png"),
                        roleName: require("../../assets/images/home/character/role/camp01/role01_name.png"),
                        roleText: `쉐라그 출신의 카란 무역회사 직원. <br>
                        실버애쉬를 생명의 은인으로 여기고 있다. 카란 무역회사와 로도스 아일랜드 간의 협정으로 인해, 현재는 로도스 아일랜드에서 파견 근무 중이다.
                        `,
                        roleCv: "히라카와 다이스케",
                        cvFile: require("../../assets/audio/character/camp01/role01/CN_011.mp3"),
                        name: 'xunshi',
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp01/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp01/role02_name.png"),
                        roleText: `
                        어려서부터 실버애쉬의 개인 안전을 줄곧 책임져온 개인 보디가드로, 꺾이지 않는 굳은 신념을 지녔다. <br>
                        쉐라그 출신이지만 실버애쉬의 요청으로 현재는 로도스 아일랜드에서 그의 둘째 여동생인 클리프하트의 개인 보디가드를 맡고 있다.
                        `,
                        roleCv: "타케우치 슌스케",
                        cvFile: require("../../assets/audio/character/camp01/role02/CN_011.mp3"),
                        name: 'jiaofeng'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp01/role04.png"),
                        roleClass: require("../../assets/images/home/character/role/guard.png"),
                        roleName: require("../../assets/images/home/character/role/camp01/role04_name.png"),
                        roleText: `쉐라그 군벌, 카란 무역회사의 대표이자 실버애쉬 가문의 현임 족장이다. <br>
                        경제무역, 국제정치, 외교수단과 전술 계획에도 일가견이 있어 로도스 아일랜드의 일부 작전에 전술 지원을 해주고 있으나, 그 목적이 불분명하고 협력 태도가 미적지근하다는 점 때문에, 로도스 아일랜드 측에선 그와 교류 시 리스크를 최소화할 수 있도록 보수적인 태도를 유지할 것을 권고하고 있다.
                        `,
                        roleCv: "코니시 카츠유키",
                        cvFile: require("../../assets/audio/character/camp01/role03/CN_011.mp3"),
                        name: "yinhui"
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp01/role03.png"),
                        roleClass: require("../../assets/images/home/character/role/spec.png"),
                        roleName: require("../../assets/images/home/character/role/camp01/role03_name.png"),
                        roleText: `암벽 등반 및 등산 쪽으로는 타의 추종을 불허하는 전문가로, 클라이밍 장비를 자신의 수족처럼 자유자재로 다룬다. 쉐라그 출신이지만 현재는 로도스 아일랜드에서 광석병 치료를 병행하며 각종 작전에 참여하고 있다.
                        `,
                        roleCv: "시라이시 료코",
                        cvFile: require("../../assets/audio/character/camp01/role04/CN_002.mp3"),
                        roleStyle: {
                        },
                        name: 'clcik_yaxin'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp01/role05.png"),
                        roleClass: require("../../assets/images/home/character/role/sup.png"),
                        roleName: require("../../assets/images/home/character/role/camp01/role05_name.png"),
                        roleText: `쉐라그 출신, 카란 성산의 성녀.<br>
                        쉐라그의 종교적 영도자로, 신이 내려주었다 전해지는 성스러운 종과 바람을 부르는 힘을 사용한다. 현재까지는 비밀 루트로 로도스 아일랜드에 도착한 것이 확인되었으나, 구체적인 담당 사무와 체류 시간은 아직 공개하기 어렵다.
                        `,
                        roleCv: "하야미 사오리",
                        cvFile: require("../../assets/audio/character/camp01/role05/CN_011.mp3"),
                        name: 'chuxue'
                    }
                ]
            },
            {
                closeImg: require("../../assets/images/home/character/camp/camp02_close.png"),
                openImg: require("../../assets/images/home/character/camp/camp02_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp02_actived.png"),
                stage: 1,
                campLogo: require("../../assets/images/home/character/role/camp02/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp02/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/vanguard.png"),
                        roleName: require("../../assets/images/home/character/role/camp02/role01_name.png"),
                        roleText: `체르노보그 사태가 발발하기 전에는 체르노보그의 어느 고등학교에 재학 중이었다. 재학기간 동안 전투와 돌격 행위에 대한 열정을 드러냈으며, 이미 여러 차례에 걸친 테스트를 통해 우르수스인 특유의 강한 힘과 강인한 체질을 보여준바가 있다.`,
                        roleCv: "코시미즈 아미",
                        cvFile: require("../../assets/audio/character/camp02/role01/CN_011.mp3"),
                        name: 'lindong'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp02/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/sup.png"),
                        roleName: require("../../assets/images/home/character/role/camp02/role02_name.png"),
                        roleText: `지혜롭고 냉철하며, 다소 내성적인 성격. 체르노보그 사태가 발발하기 전에는 체르노보그의 어느 고등학교에 재학 중이었다. 평소 추리, 정치, 경제, 변증법적 유물론 및 디저트 베이킹 잡지까지 다양한 분야의 서적을 섭렵한 이스티나는 재학 기간 중 오리지늄 아츠 관련 잡지에 여러 번 투고를 할 정도로 해박한 지식을 갖고 있다. 수차례의 테스트에서 뛰어난 제어 계열의 오리지늄 아츠를 보여준 바, 로도스 아일랜드에선 인턴 서포트 오퍼레이터로서 전투에 투입되고 있으며, 이 외에도 정보 및 자료 정리 등 다양한 업무를 맡고 있다.`,
                        roleCv: "유우키 아오이",
                        cvFile: require("../../assets/audio/character/camp02/role02/CN_011.mp3"),
                        name: 'zhenli'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp02/role03.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp02/role03_name.png"),
                        roleText: `과거 우르수스의 청소년부 스카우트 대회에서 준우승을 차지한 적이 있으며, 체르노보그 사태가 발발하기 전에는 체르노보그의 어느 고등학교에 재학 중이었다. 이미 여러 차례에 걸친 테스트를 통해 우르수스인 특유의 강인한 힘과 강인한 체질을 보여준바 인턴 디펜더 오퍼레이터로 전투에 투입되었으며, 본인의 우르수스식 요리 능력을 적극 활용, 로도스 아일랜드에서 군수 지원과 전장에서의 요리 업무 등을 담당하고 있다.
                        `,
                        roleCv: "타카모리 나츠미",
                        cvFile: require("../../assets/audio/character/camp02/role03/CN_007.mp3"),
                        name: 'gumi'
                    }
                ]
            },
            {
                closeImg: require("../../assets/images/home/character/camp/camp03_close.png"),
                openImg: require("../../assets/images/home/character/camp/camp03_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp03_actived.png"),
                stage: 2,
                campLogo: require("../../assets/images/home/character/role/camp03/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp04/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/guard.png"),
                        roleName: require("../../assets/images/home/character/role/camp04/role01_name.png"),
                        roleText: `블랙스틸 월드와이드의 용병.<br>
                        리스캄의 작전 파트너로 활약하고 있으며, 현재는 어느 특별한 이유가 있어 로도스 아일랜드에 파견된 상태이다.`,
                        roleCv: "카쿠마 아이",
                        cvFile: require("../../assets/audio/character/camp03/role01/CN_020.mp3"),
                        name: 'salanka'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp04/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp04/role02_name.png"),
                        roleText: `블랙스틸 월드와이드 프라이빗 시큐리티 컨설팅의 용병.<br>
                        무력 충돌 지역에서 쌓은 풍부한 실전 경험을 기반으로, 현재는 계약 기간 동안 로도스 아일랜드에서 시큐리티 서비스 및 컨설팅을 제공하고 있다.
                        `,
                        roleCv: "이시카와 유이",
                        cvFile: require("../../assets/audio/character/camp03/role02/CN_011.mp3"),
                        name: 'leishe'
                    }
                ]
            },
            {
                closeImg: require("../../assets/images/home/character/camp/camp04_close.png"),
                openImg: require("../../assets/images/home/character/camp/camp04_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp04_actived.png"),
                stage: 3,
                campLogo: require("../../assets/images/home/character/role/camp04/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp03/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp03/role01_name.png"),
                        roleText: `
                        용문근위국 특별감찰팀의 정예 오퍼레이터. <br>
                        범죄전과 : 있음.<br>
                        용문 총독 웨이옌우와의 교섭을 통해, 파격적인 대우로 용문근위국 특별임무팀에 합류하게 되었다. 현재는 디펜더 오퍼레이터로서 로도스 아일랜드에 협조 중이며, 현장에서 전술 집행 및 지휘 지원을 맡고 있다.`,
                        roleCv: "야스노 키요노",
                        cvFile: require("../../assets/audio/character/camp04/role01/CN_004.mp3"),
                        imgStyle: {
                            "margin-left": "-30px"
                        },
                        name: 'xingxiong',
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp03/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/guard.png"),
                        roleName: require("../../assets/images/home/character/role/camp03/role02_name.png"),
                        roleText: `
                        용문근위국 특별감찰팀장.<br>
                        용문 내 벌어지는 위법 행위 및 조직적 범죄 행위의 근절을 강력히 주장한 것으로 유명하며, 실제로도 뚜렷한 성과를 거두었다. 현재는 특별협력인원 신분으로 로도스 아일랜드와 함께 행동하고 있으며, 현장에서 전술 지휘를 지원하고 있다.
                        `,
                        roleCv: "이시가미 시즈카",
                        cvFile: require("../../assets/audio/character/camp04/role02/CN_005.mp3"),
                        name: 'chen'
                    }
                ]
            },
            {
                closeImg: require("../../assets/images/home/character/camp/camp05_close.png"),
                openImg: require("../../assets/images/home/character/camp/camp05_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp05_actived.png"),
                stage: 4,
                campLogo: require("../../assets/images/home/character/role/camp05/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp05/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/caster.png"),
                        roleName: require("../../assets/images/home/character/role/camp05/role01_name.png"),
                        roleText: `매우 높은 오리지늄 적응력과 다발성 발화 현상을 보이고 있는 감염자. 광석병 중증 감염자로서 라인 생명연구소의 치료대상이었던 과거를 갖고 있지만, 라인 생명연구소로 오기 전의 기록은 전부 소실된 상태이다. 현재는 로도스 아일랜드에서 치료를 받고 있으며, 메딕 오퍼레이터 사일런스가 이프리트의 담보와 감호를 담당하고 있다. `,
                        roleCv: "하나모리 유미리",
                        cvFile: require("../../assets/audio/character/camp05/role01/CN_011.mp3"),
                        name: 'yifulite'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp05/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp05/role02_name.png"),
                        roleText: `라인 생명연구실의 전임 방위부서 주임. 생명과학, 미생물학, 오리지늄 아츠 등 다양한 영역에서 그 공로를 인정받았으며, 이 밖에도 섬멸전과 요원의 안전 확보, 이상 사태 처리 등 다른 임무에서도 상당한 실력을 드러내고 있다. 현재는 과학연구 등 다양한 영역에서 로도스 아일랜드에 협력하는 한편, 로도스 아일랜드와의 협력 계획 관련 협의에도 지속적으로 힘쓰고 있다. `,
                        roleCv: "이구치 유카",
                        cvFile: require("../../assets/audio/character/camp05/role02/CN_011.mp3"),
                        name: 'saileiya'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp05/role03.png"),
                        roleClass: require("../../assets/images/home/character/role/medic.png"),
                        roleName: require("../../assets/images/home/character/role/camp05/role03_name.png"),
                        roleText: `라인 생명연구소의 전임 데이터 관리원.<br>순간 치료 및 데이터 총괄 정리에 정통하다. 냉정하고 정확하게 모든 업무를 처리하며, 마치 기계처럼 완벽하게 자신의 임무를 완수한다.`,
                        roleCv: "카네모토 히사코",
                        cvFile: require("../../assets/audio/character/camp05/role03/CN_011.mp3"),
                        name: 'baimiange'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp05/role04.png"),
                        roleClass: require("../../assets/images/home/character/role/medic.png"),
                        roleName: require("../../assets/images/home/character/role/camp05/role04_name.png"),
                        roleText: `라인 생명연구소의 오리지늄 연구원.<br>과거 미확인 응용 연구 항목을 수회 주관한 적이 있으며, 같은 기간 중 광석병 임상 실험 연구도 여러차례 담당했었다. 현재는 로도스 아일랜드에서 여러 작전에 참여하며 전장 의료 구호 서비스를 제공하고 있다.`,
                        roleCv: "키토우 아카리",
                        cvFile: require("../../assets/audio/character/camp05/role04/CN_001.mp3"),
                        name: 'mohe'
                    }
                ]
            },
            {
                closeImg: require("../../assets/images/home/character/camp/camp06_close.png"),
                openImg: require("../../assets/images/home/character/camp/camp06_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp06_actived.png"),
                stage: 5,
                campLogo: require("../../assets/images/home/character/role/camp06/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp06/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/sniper.png"),
                        roleName: require("../../assets/images/home/character/role/camp06/role01_name.png"),
                        roleText: `라테라노 공민. 펭귄 로지스틱스의 직원.<br>비밀연락, 무장호송 등의 비공개 임무 처리를 담당하고 있으며, 주로 메신저 역할을 하고 있는 것으로 추측된다. 계약 기간 중 펭귄 로지스틱스와의 연락망 유지를 위해 로도스 아일랜드에 상주하고 있으며, 로도스 아일랜드에 작전협력을 제공하고 있다.`,
                        roleCv: "이와미 마나카",
                        imgStyle: {
                        },
                        cvFile: require("../../assets/audio/character/camp06/role01/CN_007.mp3"),
                        name: 'nengtianshi'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp06/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/vanguard.png"),
                        roleName: require("../../assets/images/home/character/role/camp06/role02_name.png"),
                        roleText: `펭귄 로지스틱스의 직원. <br>비밀연락, 무장호송 등의 비공개 임무 처리를 담당하고 있으며, 주로 메신저 역할을 하고 있는 것으로 추측된다. 계약 기간 중 펭귄 로지스틱스와의 연락망 유지를 위해 로도스 아일랜드에 상주하고 있으며, 로도스 아일랜드에 작전협력을 제공하고 있다.`,
                        roleCv: "타도코로 아즈사",
                        cvFile: require("../../assets/audio/character/camp06/role02/CN_003.mp3"),
                        name: 'dekesasi'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp06/role03.png"),
                        roleClass: require("../../assets/images/home/character/role/sup.png"),
                        roleName: require("../../assets/images/home/character/role/camp06/role03_name.png"),
                        roleText:
                            "현역 아이돌로 활동 중이지만, 모종의 이유로 인해 잠시 펭귄 로지스틱스에 기거하고 있다. 펭귄 로지스틱스와 로도스 아일랜드가 서로 협력하게 된 이후로는 로도스 아일랜드의 일원으로서도 작전에 참여하고 있다. 목소리에 마력을 담아 사용하는 특수 기술을 갖고 있으며, 전장에서는 주로 이를 통해 동료 오퍼레이터에게 서포트를 제공하고 있다.",
                        roleCv: "스즈키 미노리",
                        imgStyle: {
                        },
                        cvFile: require("../../assets/audio/character/camp06/role03/CN_002.mp3"),
                        name: 'kong'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp06/role04.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp06/role04_name.png"),
                        roleText: `펭귄 로지스틱스의 직원. <br>밝고 명량한 성격으로, 쇼핑을 상당히 좋아한다. 늘 자신의 생활 수준을 높이기 위해 매일 열심히 일하고 있다.`,
                        roleCv: "쿠보 유리카",
                        cvFile: require("../../assets/audio/character/camp06/role04/CN_002.mp3"),
                        name: 'kesong'
                    }
                ]
            },
            {
                closeImg: require("../../assets/images/home/character/camp/camp07_close.png"),
                openImg: require("../../assets/images/home/character/camp/camp07_open.png"),
                activedImg: require("../../assets/images/home/character/camp/camp07_actived.png"),
                stage: 6,
                campLogo: require("../../assets/images/home/character/role/camp07/logo.png"),
                rolelist: [
                    {
                        roleImg: require("../../assets/images/home/character/role/camp07/role01.png"),
                        roleClass: require("../../assets/images/home/character/role/spec.png"),
                        roleName: require("../../assets/images/home/character/role/camp07/role01_name.png"),
                        roleText: `
                        버림받은 아이. <br>
                        자신이 '외할머니' 라 부르는 인물의 손에서 길러졌다. 이때부터, 그녀는 동족들에게 점차 공포의 대상이 되어갔다.
                        `,
                        roleCv: "코시미즈 아미",
                        cvFile: require("../../assets/audio/character/camp07/role01/CN_019.mp3"),
                        name: 'hong'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp07/role02.png"),
                        roleClass: require("../../assets/images/home/character/role/medic.png"),
                        roleName: require("../../assets/images/home/character/role/camp07/role02_name.png"),
                        roleText: `
                        로도스 아일랜드의 프로젝트 리더. <br>
                        다양한 분야에 해박한 지식을 갖고 있어, 로도스 아일랜드의 일부 작전 수행 중 메딕 오퍼레이터로서 의학 이론 관련 지식과 응급의료기구를 제공한다.
                        `,
                        roleCv: "히카사 요코",
                        cvFile: require("../../assets/audio/character/camp07/role02/CN_002.mp3"),
                        name: 'kaierxi'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp07/role03.png"),
                        roleClass: require("../../assets/images/home/character/role/caster.png"),
                        roleName: require("../../assets/images/home/character/role/camp07/role03_name.png"),
                        roleText: `로도스 아일랜드의 공식적인 리더.`,
                        roleCv: "쿠로사와 토모요",
                        cvFile: require("../../assets/audio/character/camp07/role03/CN_012.mp3"),
                        name: 'amiya'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp07/role04.png"),
                        roleClass: require("../../assets/images/home/character/role/guard.png"),
                        roleName: require("../../assets/images/home/character/role/camp07/role04_name.png"),
                        roleText: `로도스 아일랜드의 전술 훈련 교관.<br>엄격하고 깐깐하여 빈틈이 없는 성격으로, 단 한 명의 동료도 전장에서 목숨을 잃지 않게 하기 위해 연일 전술 훈련 감독에 힘을 쏟고 있다.`,
                        roleCv: "타네자키 아츠미",
                        cvFile: require("../../assets/audio/character/camp07/role04/CN_002.mp3"),
                        name: 'dubin'
                    },
                    {
                        roleImg: require("../../assets/images/home/character/role/camp07/role05.png"),
                        roleClass: require("../../assets/images/home/character/role/defe.png"),
                        roleName: require("../../assets/images/home/character/role/camp07/role05_name.png"),
                        roleText: `로도스 아일랜드의 디펜더 오퍼레이터. <br>매사 성실하고 진지한 성격의 그녀는, 로도스의 방패이자 동료를 수호하는 방패 그 자체다.
                        `,
                        roleCv: "사쿠라 아야네",
                        cvFile: require("../../assets/audio/character/camp07/role05/CN_002.mp3"),
                        imgStyle: {
                            "margin-left": '-15px'
                        },
                        name: 'linguang'
                    }
                ]
            }
        ],
        showCamp: false,
        showRole: false, // 显示角色列表
        firstShow: true, // 第一次进入该版块
        seledCampData: "", // 选中的阵营数据
        hoverIndex: -1, // 鼠标mouseover角色index,
        seledRole: "", // 选中的角色数据
        seledRoleIndex: -1, // 选中角色index
        staticPath: process.env.VUE_APP_STATIC,

        // audio
        playing: false,
        canplay: false,

        // cv btn
        cvHoverLeft: 0,
        cvHoverTop: 0,
        cvHoverWidth: 0,
        cvHoverHeight: 0,
    }),
    created() {

    },
    mounted() {
        window.addEventListener("resize", this.$utils.debounce(() => {
            if(this.seledRoleIndex != -1) {
                this.setCvBtnPosit(0)
            }
        }, this, 500))
    },
    watch: {
        NAV_ACTIVE_INDEX(val) {
            if (val == 2 && this.firstShow) {
                this.firstShow = false;

                setTimeout(() => {
                    this.showCamp = true;
                }, 500);
            }
            if(this.seledRole) {
                this.clearAudioState();
            }
        }
    },
    computed: {
        CAMP_STAGE() {
            return 6;
        },
        ...mapGetters({
            NAV_ACTIVE_INDEX: 'Home/NAV_ACTIVE_INDEX'
        }),
        cvHoverPosit() {
            return {
                'left': this.cvHoverLeft + 'px',
                'top': this.cvHoverTop + 'px',
                'width': this.cvHoverWidth + 'px',
                'height': this.cvHoverHeight + 'px'
            }
        }
    },
    methods: {
        playAudio() {
            if (this.playing) {
                this.$refs['say'].pause()
            } else {
                this.$refs['say'].play()
            }
        },
        pause() {
            this.playing = false
        },
        clearAudioState() {
            this.$refs['say'].currentTime = 0
            this.$refs['say'].pause()
            this.playing = false
        },
        campBg(item) {
            if (item.stage <= this.CAMP_STAGE) {
                return item.openImg;
            } else {
                return item.closeImg;
            }
        },
        slideType(index) {
            if (index % 2 == 0) {
                return "slideTop";
            } else {
                return "slideBottom";
            }
        },
        showCampRole(item, disable) {
            if (disable) {
                return;
            }
            // 隐藏阵营
            this.showCamp = false;
            this.showRole = true;
            this.seledCampData = item;
        },
        moverRole(index) {
            if (this.seledRoleIndex != -1) {
                // 选中角色后禁止mouse事件
                return;
            }
            this.hoverIndex = index;
        },
        mouseleaveRole() {
            if (this.seledRoleIndex != -1) {
                // 选中角色后禁止mouse事件
                return;
            }
            this.hoverIndex = -1;
        },
        hoverClass(index) {
            if (this.hoverIndex == -1) {
                return "";
            } else if (this.hoverIndex == index) {
                // hover角色
                return "hover-active";
            } else if (this.hoverIndex < index) {
                return "hover-right";
            } else if (this.hoverIndex > index) {
                return "hover-left";
            }
        },
        seledClass(index) {
            if (this.seledRoleIndex == -1) {
                return "";
            } else if (this.seledRoleIndex == index) {
                return "sel-active";
            } else {
                return "no-sel-active";
            }
        },
        posLeft(index, roleLength) {
            if (roleLength == 2) {
                let posleft = 30 + index * 20 + "%";
                return {
                    left: posleft
                };
            } else {
                let posleft = (index / roleLength) * 100 + "%";
                return {
                    left: posleft
                };
            }
        },
        selRole(index, locked) {
            if (locked) {
                return;
            }

            this.seledRole = this.seledCampData.rolelist[index];
            this.hoverIndex = -1;
            this.seledRoleIndex = index;


            this.setCvBtnPosit(800);

            // 发送ga、fb分事件
            console.log("role name: ", this.seledRole.name, gtag, fbq)
            gtag('event', this.seledRole.name, {
                'event_category': 'engagement',
                'event_label': 'not set'
            })
            fbq('trackCustom', this.seledRole.name)
        },
        closeRole() {
            this.seledRole = "";
            this.seledRoleIndex = -1;
        },
        returnCamplist() {
            this.showCamp = true;
            this.showRole = false;
            this.seledCampData = "";

            setTimeout(() => {
                this.closeRole();
            }, 50)
        },
        setCvBtnPosit(delay) {
            setTimeout(() => {
                this.cvHoverLeft = this.$refs['role-cv-box'][this.seledRoleIndex].getBoundingClientRect().left;
                this.cvHoverTop = this.$refs['role-cv-box'][this.seledRoleIndex].getBoundingClientRect().top;
                this.cvHoverWidth = this.$refs['role-cv-box'][this.seledRoleIndex].getBoundingClientRect().width;
                this.cvHoverHeight = this.$refs['role-cv-box'][this.seledRoleIndex].getBoundingClientRect().height;
            }, delay)
        },
        jumpToCv() {
            let camplist = ['camp01', 'camp02', 'camp03', 'camp04', 'camp05', 'camp06', 'camp07']
            window.open(`${window.location.href}${camplist[this.seledCampData.stage]}`, '_blank')
        }
    },
};
</script>

<style lang="scss" scoped>
.character-wrap {
    background: #000 url("../../assets/images/home/character/bg_02.png") no-repeat;
    background-size: cover;
    background-position: center top;
    position: relative;
    overflow: hidden;

    &.mask {
        &::after {
            opacity: 1;
        }
    }

    &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: #141516;
        z-index: 1;
        opacity: 0;
        transition: all 0.3s ease-in-out;
    }

    .camp-wrap {
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 3;

        .camp-container {
            display: flex;
            .camp-box {
                flex-grow: 0;
                width: auto;
                height: pxTorem(800px);
                cursor: pointer;
                position: relative;
                background: #141516;

                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    transition: all 0.8s;
                }

                &:not(:first-child) {
                    margin-left: pxTorem(-50px);
                }

                &:nth-of-type(1) {
                    z-index: 10;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp01_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(2) {
                    z-index: 9;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp02_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(3) {
                    z-index: 8;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp03_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(4) {
                    z-index: 7;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp04_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(5) {
                    z-index: 6;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp05_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(6) {
                    z-index: 5;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp06_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }
                &:nth-of-type(7) {
                    z-index: 4;
                    &::after {
                        background: url("../../assets/images/home/character/camp/camp07_actived.png")
                            no-repeat;
                        background-size: 100%;
                        background-position: center 100%;
                    }
                }

                .camp-bg {
                    display: block;
                    height: 100%;
                }

                &.actived {
                    &:hover {
                        &::after {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
    .camp-logo {
        position: absolute;
        z-index: 10;
        width: pxTorem(280px);
        top: pxTorem(150px);
        left: pxTorem(50px);
        cursor: pointer;

        &:hover {
            img {
                transform: scale(-1, 1);
            }
        }

        img {
            width: 100%;
            transition: all 0.3s;
        }
    }
    .role-wrap {
        position: absolute;
        top: 55%;
        left: 55%;
        transform: translate(-50%, -50%);
        z-index: 2;
        width: 70%;
        height: 80%;
        box-sizing: border-box;

        .role-container {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            position: relative;

            .role-box {
                width: pxTorem(270px);
                height: 100%;
                box-sizing: border-box;

                .role-content {
                    width: pxTorem(270px);
                    height: 100%;
                    position: absolute;
                    top: 0;
                    transition: transform 0.2s ease-in-out, all 0.3s ease-in-out;

                    /* detail */
                    .role-detail {
                        width: pxTorem(596px);
                        position: absolute;
                        top: 53%;
                        left: 100%;
                        z-index: -1;
                        box-sizing: border-box;
                        padding: pxTorem(25px) pxTorem(20px) pxTorem(25px)
                            pxTorem(150px);
                        background: rgba(20, 21, 22, 0.9);
                        transform: translateY(-50%) scaleX(1);
                        transition: all 0.3s ease-in-out;

                        .role-class {
                            height: pxTorem(110px);
                            position: absolute;
                            left: pxTorem(35px);
                            top: pxTorem(-55px);
                            background: #eaeaea;
                            box-sizing: border-box;
                            padding: pxTorem(20px) 0 pxTorem(20px) pxTorem(50px);
                            img {
                                height: 100%;
                            }
                        }
                        .role-close {
                            color: #fff;
                            font-size: pxTorem(35px);
                            position: absolute;
                            left: 100%;
                            top: 0;
                            transform: translateY(-100%);
                            cursor: pointer;
                        }
                        .role-name-cv-box {
                            width: 100%;
                            height: pxTorem(80px);
                            display: flex;
                            justify-content: space-between;

                            .role-name {
                                flex-grow: 0;
                                height: 80%;
                                img {
                                    height: 100%;
                                }
                            }
                            .role-cv {
                                width: pxTorem(116px);
                                height: auto;
                                align-self: flex-end;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;

                                .role-cv-box {
                                    position: relative;
                                    .cv-btn {
                                        height: 120%;
                                    }
                                    &::after {
                                        content: "";
                                        display: block;
                                        position: absolute;
                                        width: 100%;
                                        height: 100%;
                                        top: 0;
                                        left: 0;
                                        background: url("../../assets/images/home/character/role/role_cv.png") no-repeat;
                                        background-size: 100% 100%;
                                        opacity: 0;
                                    }
                                    &::before {
                                        content: "";
                                        display: block;
                                        width: 40%;
                                        height: 40%;
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                        z-index: -1;
                                        box-shadow: 0 0 20px 1px #007eff;
                                        border-radius: 50%;
                                        animation: lightScale 1s ease-in-out alternate infinite;
                                        opacity: 0;

                                        @keyframes lightScale {
                                            from {
                                                box-shadow: 0 0 20px 1px #007eff;
                                            }
                                            to {
                                                box-shadow: 0 0 20px 10px #007eff;
                                            }
                                        }
                                    }
                                    &.play {
                                        &::after {
                                            opacity: 1;
                                        }
                                        &::before {
                                            opacity: 1;
                                        }
                                    }
                                }
                                
                                .cv {
                                    font-size: pxTorem(16px);
                                    color: #fff;
                                    white-space: nowrap;
                                    font-family: 'Noto Sans KR', sans-serif;
                                    font-weight: 700;
                                }
                            }
                        }
                        .role-text {
                            width: 100%;
                            margin-top: pxTorem(35px);
                            font-size: pxTorem(16px);
                            color: #fff;
                            font-family: 'Noto Sans KR', sans-serif;
                            font-weight: 700;
                            word-break: keep-all;
                        }
                    }

                    &.sel-active {
                        left: 15% !important;
                        z-index: 999;

                        .role {
                            width: pxTorem(800px);
                            height: pxTorem(800px);
                        }
                    }
                    &.no-sel-active {
                        .role {
                            filter: brightness(0.4);
                        }
                    }

                    &.hover-active {
                        transform: scale(1.1);
                    }
                    &.hover-left {
                        transform: translateX(pxTorem(-20px));
                    }
                    &.hover-right {
                        transform: translateX(pxTorem(20px));
                    }

                    .role {
                        position: absolute;
                        width: pxTorem(600px);
                        height: pxTorem(600px);
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        transition: all 0.3s ease-in-out;
                    }
                }
            }
        }
        .mover-container {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 0;

            .mover-box {
                width: pxTorem(270px);
                height: 60%;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                box-sizing: border-box;
                cursor: pointer;
            }
        }
        .cv-more {
            position: absolute;
            z-index: 999;
            color: #fff;
            font-size: pxTorem(22px);
            font-family: 'Noto Sans KR', sans-serif;
            bottom: 1%;
            right: pxTorem(-100px);
            cursor: pointer;
            display: flex;
            align-items: center;

            &::after {
                content: ">>>";
                display: inline-block;
                font-family: 'Noto Sans KR', sans-serif;
                font-size: pxTorem(35px);
                margin-left: pxTorem(20px);
            }
        }
    }
    .cv-hover {
        position: absolute;
        z-index: 999;
        // background: lightskyblue;
        cursor: pointer;
    }
}

/* camp */
.slideTop-enter-active,
.slideTop-leave-active {
    transition: all 0.5s ease-in-out;
}
.slideTop-enter,
.slideTop-leave-to {
    transform: translateY(-100%) translateZ(0);
    opacity: 0;
}
.slideBottom-enter-active,
.slideBottom-leave-active {
    transition: all 0.5s ease-in-out;
}
.slideBottom-enter,
.slideBottom-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
/* role-class */
.roleClass-enter-active,
.roleClass-leave-active {
    transition: all 0.2s ease-in-out !important;
    transform-origin: left center !important;
}
.roleClass-enter-active {
    transition-delay: 0.5s !important;
}
.roleClass-enter,
.roleClass-leave-to {
    transform: scaleX(0) !important;
}
/* role-detail */
.roleDetail-enter-active,
.roleDetail-leave-active {
    transition: transform 0.3s ease-in-out !important;
    transform-origin: left center !important;
}
.roleDetail-enter-active {
    transition-delay: 0.3s !important;
}
.roleDetail-enter,
.roleDetail-leave-to {
    transform: translateY(-50%) scaleX(0) !important;
}
</style>
